<template>
  <!-- 职业定位特训营 -->
  <div class="career-orientation" v-if="bodyShow">
    <!-- banner部分 -->
    <div class="banner">
      <img :src="info.cover" alt />
      <span>{{info.count}} 人已购买</span>
    </div>
    <!-- 内容部分 -->
    <div class="content">
        <div v-html="info.detail"></div>
        <!-- 7天的职业定位训练营原价199元，拼团仅需9.9元-->
        <h3 class="on-money">{{info.name}}<br/>原价{{info.price}}元，<span>现在仅需{{info.missionPrice}}元</span></h3>
    </div>
    <!-- 学习须知 -->
    <div class="learning-instructions">
      <h3>学习须知</h3>
      <div class="instructions-content">
        <p>1. 申请添加班主任会在48小时内通过，请耐心等待哦。</p>
        <p>2. 报名后班主任会跟进排期安排最近期次入学。</p>
      </div>
    </div>
    <p class="on">*本训练营由新精英生涯（北京）教育科技有限公司版权所有，违者必究</p>
    <!-- 立即报名按钮 -->
    <a class="sign-up" v-if="!info.buy" @click="signHandle('common',0)">
      立即报名 ¥ {{info.missionPrice}}&nbsp;
      <del>原价¥{{info.price}}</del>
    </a>
    <router-link class="sign-up" v-else :to="{
        path:'/teacher_code',
        query:{
            course_id:this.$route.query.course_id
        }
    }">查看班主任微信</router-link>
    <public-mobile ref="handle" :orientation_pay="orientation_pay"></public-mobile>
  </div>
</template>

<script>
import { activity } from "@/api/training";
import { shareCon } from "@/utils/wxconfig";
export default {
  data() {
    return {
      bodyShow: false,
      info: {},
      orientation_pay:{} //支付所需参数对象
    }
  },
  methods: {
    /*
     *@param: 
     *@return: 
     *@Description: 7天职业定向特训营支付
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-12 14:28:09
    */
    signHandle(type, mission_type) {
        let q = this.$route.query;
        // 写入支付所需参数
      this.orientation_pay = {
        utm_campaign:q.utm_campaign  || '',
        utm_source:q.utm_source  || '',  //广告系列来源广告系列来源
        utm_medium:q.utm_medium  || '',//广告系列媒介
        utm_term:q.utm_term  || '', //广告系列关键词
        utm_content:q.utm_content || '', //广告系列内容
        mission_id:this.info.missionId, //拼团ID
        course_id: q.course_id
      };
      setTimeout(() => {
        this.$refs.handle.pay_orientation();
      }, 200);
    },
    /*
     *@Description: 初始化方法
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-12 14:28:38
    */
    pullData() {
      this.$toast.loading({
        mask: true,
        message: "加载中..."
      });
      activity({
        course_id: this.$route.query.course_id
      }).then(data => {
        if (data.code == 10002) {
          this.$toast(data.data.msg);
          return;
        }
        document.title = data.info.name;
        this.info = data.info;
        this.bodyShow = true;
        this.$toast.clear();
      });
    }
  },
  created() {
    this.pullData();
    shareCon("training", this);
  }
};
</script>
<style lang="scss" scoped>
.banner {
  position: relative;
  span {
    position: absolute;
    right: 0;
    bottom: 32px;
    font-size: 24px;
    padding: 8px 26px 8px 16px;
    border-radius: 19px 0px 0px 19px;
    background-color: #eb5032;
    color: #ffffff;
    display: block;
  }
}
.learning-instructions {
  margin: 0 26px;
  padding: 32px 50px 70px;
  background-color: #ffffff;
  h3 {
    display: block;
    margin: 0 auto;
    text-align: center;
    font-weight: bold;
    letter-spacing: 1px;
    line-height: 65px;
    background-color: #f5b417;
    color: #333333;
    border-radius: 8px 8px 0px 0px;
  }
  .instructions-content {
    padding: 30px 20px;
    p {
      text-align: left;
      font-size: 26px;
      color: #333333;
      line-height: 39px;
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
.content{
    position: relative;
    .on-money{
        display: block;
        width: 100%;
        padding: 0 134px;
        box-sizing: border-box;
        position: absolute;
        text-align: center;
        bottom: 84px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 36px;
        color: #333333;
        span{
            color: #EB5032;
        }
    }
}

p.on {
  font-size: 24px;
  color: #666666;
  margin: 30px 32px 173px;
}
.sign-up {
  display: flex;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  line-height: 98px;
  background-color: #eb5032;
  color: #ffffff;
  font-size: 34px;
  justify-content: center;
  del {
    font-size: 24px;
  }
}
</style>

<style lang="scss">
.career-orientation {
  img {
    width: 100%;
  }
}
</style>
